import PropTypes from 'prop-types'
import React, { Component } from 'react'
import SubNavigation from 'ui/SubNavigation'
import css from './CustomersHome.module.css'

class CustomersHome extends Component {
  render () {
    const { pathname } = window.location
    const pathParts = pathname.split('/').filter(Boolean)
    const section = this.getActiveSection(pathParts[2])

    const items = [
      this.createNavItem('Profiles', 'profiles', true),
      this.createNavItem('API Access', 'settings', true)
    ]

    return (
      <div className={css.fullHeight}>
        <SubNavigation title='Users' items={items} active={section} />
        {this.props.children}
      </div>
    )
  }

  createNavItem (name, suffix, isVisible, badge) {
    return {
      href: `/${this.props.workspace.slug}/customers/${suffix}`,
      name: name,
      visible: isVisible,
      badge: badge
    }
  }

  getActiveSection (part) {
    const mapping = {
      profiles: 'Profiles',
      settings: 'API Access'
    }
    return mapping[part]
  }
}

CustomersHome.displayName = 'CustomersHome'

CustomersHome.propTypes = {
  children: PropTypes.node.isRequired
}

export default CustomersHome



// WEBPACK FOOTER //
// ./components/Customers/CustomersHome.js